<template>
    <div class="mod-user">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
<!--            <el-form-item>-->
<!--                <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item>-->
<!--                <el-button @click="getDataList()">查询</el-button>-->
<!--                <el-button type="primary" @click="addOrUpdateHandle()">部署</el-button>-->
<!--            </el-form-item>-->
        </el-form>
        <el-table
                :data="dataList"
                border
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
            <el-table-column
                    prop="processId"
                    header-align="left"
                    align="left"
                    label="流程定义编号">
            </el-table-column>
            <el-table-column
                    prop="deploymentId"
                    header-align="left"
                    align="left"
                    label="部署编号">
            </el-table-column>
            <el-table-column
                    prop="processName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="key"
                    header-align="left"
                    align="left"
                    label="流程键值">
            </el-table-column>
            <el-table-column
                    prop="version"
                    header-align="left"
                    align="left"
                    label="版本号">
            </el-table-column>
            <el-table-column
                    prop="xml"
                    header-align="left"
                    align="left"
                    label="xml">
                <template slot-scope="scope">
                    <a v-bind:href="getXmlUrl(scope.row.processId)" target="_blank">{{scope.row.xml}}</a>
                </template>
            </el-table-column>
            <el-table-column
                    prop="xml"
                    header-align="left"
                    align="left"
                    label="xml">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="showImgHandler(scope.row.processId)" target="_blank">{{scope.row.xml}}</a>
                </template>
            </el-table-column>
            <el-table-column
                    prop="deployTime"
                    header-align="center"
                    align="center"
                    width="180"
                    label="部署时间">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.deploymentId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
<!--        <el-pagination-->
<!--                @size-change="sizeChangeHandle"-->
<!--                @current-change="currentChangeHandle"-->
<!--                :current-page="pageIndex"-->
<!--                :page-sizes="[10, 20, 50, 100]"-->
<!--                :page-size="pageSize"-->
<!--                :total="totalPage"-->
<!--                layout="total, sizes, prev, pager, next, jumper">-->
<!--        </el-pagination>-->
    </div>
</template>

<script>

    export default {
        data () {
            return {
                dataForm: {
                    searchKey: ''
                },
                key:this.$route.query.key,
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                showImgVisible: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        activated () {
            this.getDataList()
        },
        methods: {
            getXmlUrl(id){
                return '/api/workflow/resource/read?processDefinitionId='+id+'&resourceType=xml'
            },
            showImgHandler(id){
                let url= '/api/workflow/resource/read?processDefinitionId='+id+'&resourceType=image'
                this.showImgVisible = true
                this.$nextTick(() => {
                    this.$refs.showImg.init(url)
                })
            },
            // 获取数据列表
            getDataList () {
                this.dataListLoading = true
                this.$http.post(`/workflow/getHistoryList?definitionKey=${this.key}`).then(({data}) => {
                    if (data ) {
                        this.dataList = data
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle (val) {
                this.dataListSelections = val
            },
            // 删除
            deleteHandle (id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        // url: this.$http.adornUrl('/workflow/delete'),
                        url: `/workflow/delete?deploymentId=${id}`,
                        method: 'post',
                        // deploymentId : id
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>